import React, { useState } from 'react';
import {
    Card,
    CardHeader,
    CardTitle,
    DescWrapper,
    IconsWrapper,
    LeftColumn,
    OpenedSection,
    RightColumn,
    Title,
} from './style';
import { InfoTableData } from '../../typings';

interface InfoTableProps {
    isWeb: boolean;
    cardTitle?: string;
    tableData: InfoTableData;
}

const InfoTable = (props: InfoTableProps) => {
    const { isWeb, cardTitle, tableData } = props;

    const [sectionIsOpen, setSectionIsOpen] = useState<boolean>(false);

    const upIcon = (
        <svg
            width="15"
            height="10"
            viewBox="0 0 28 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M14.6207 14.9388L14.6214 14.9382L26.1647 3.5098C26.1649 3.5096 26.1651 3.5094 26.1653 3.50921C26.306 3.37045 26.4178 3.20512 26.4942 3.0228C26.5706 2.84022 26.61 2.64426 26.61 2.44632C26.61 2.24838 26.5706 2.05242 26.4942 1.86984C26.4178 1.6874 26.3059 1.52196 26.165 1.38314C25.881 1.10302 25.4982 0.945975 25.0993 0.945975C24.7015 0.945975 24.3197 1.10215 24.0359 1.3808L13.5557 11.4687L3.074 1.38075C2.79028 1.10213 2.40847 0.945976 2.01073 0.945976C1.61198 0.945976 1.22927 1.10291 0.945323 1.38284C0.804286 1.52172 0.69228 1.68727 0.615827 1.86984L1.07702 2.06297L0.615826 1.86984C0.539373 2.05242 0.5 2.24838 0.5 2.44632C0.5 2.64426 0.539373 2.84022 0.615826 3.0228L1.07635 2.82996L0.615827 3.0228C0.692198 3.20518 0.804045 3.37057 0.944868 3.50936C0.94502 3.50951 0.945172 3.50965 0.945323 3.5098L12.4886 14.9382L12.4893 14.9388C12.7733 15.2189 13.1561 15.376 13.555 15.376C13.9539 15.376 14.3367 15.2189 14.6207 14.9388Z"
                fill="#40596F"
                stroke="#40596F"
            />
        </svg>
    );

    const downIcon = (
        <svg
            width="15"
            height="10"
            viewBox="0 0 22 13"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M20 11.1826L11 2.00034L2 11.1826"
                stroke="#435970"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );

    const checkMarkIcon = (
        <svg
            width="24"
            height="25"
            viewBox="0 0 27 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <circle cx="13.5" cy="14.376" r="13.5" fill="#1AA6AD" />
            <path
                d="M11.4808 20.1384C11.3526 20.138 11.2258 20.1112 11.1084 20.0597C10.9909 20.0082 10.8853 19.9332 10.7981 19.8392L6.25348 15.0046C6.08359 14.8236 5.99258 14.5824 6.00047 14.3343C6.00837 14.0861 6.11451 13.8513 6.29556 13.6814C6.4766 13.5115 6.71772 13.4205 6.96587 13.4284C7.21401 13.4363 7.44886 13.5424 7.61875 13.7235L11.4714 17.8287L19.3358 9.22558C19.4156 9.12619 19.5149 9.04418 19.6275 8.98456C19.7402 8.92495 19.8638 8.88899 19.9909 8.87891C20.118 8.86882 20.2457 8.88482 20.3664 8.92592C20.487 8.96702 20.598 9.03234 20.6925 9.11789C20.787 9.20344 20.863 9.3074 20.9158 9.42339C20.9687 9.53938 20.9973 9.66495 20.9998 9.79239C21.0024 9.91982 20.9788 10.0464 20.9307 10.1644C20.8825 10.2825 20.8107 10.3894 20.7197 10.4786L12.1728 19.8298C12.0864 19.9255 11.9812 20.0023 11.8637 20.0554C11.7462 20.1086 11.619 20.1368 11.4901 20.1384H11.4808Z"
                fill="white"
            />
        </svg>
    );

    const exclamationMarkIcon = (
        <svg
            width="24"
            height="25"
            viewBox="0 0 27 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <circle cx="13.5" cy="14.376" r="13.5" fill="#F2D04B" />
            <path
                d="M12.32 7.87598H15.28L14.78 17.236H12.8L12.32 7.87598ZM13.8 22.016C13.3333 22.016 12.9467 21.8693 12.64 21.576C12.3333 21.2693 12.18 20.896 12.18 20.456C12.18 20.016 12.3333 19.6493 12.64 19.356C12.9467 19.0626 13.3333 18.916 13.8 18.916C14.2533 18.916 14.6267 19.0626 14.92 19.356C15.2267 19.6493 15.38 20.016 15.38 20.456C15.38 20.896 15.2267 21.2693 14.92 21.576C14.6267 21.8693 14.2533 22.016 13.8 22.016Z"
                fill="white"
            />
        </svg>
    );

    const questionMarkIcon = (
        <svg
            width="24"
            height="27"
            viewBox="0 0 27 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <circle cx="13.5" cy="14.751" r="13.5" fill="#40596F" />
            <path
                d="M11.996 17.075C11.996 16.427 12.14 15.893 12.428 15.473C12.728 15.041 13.16 14.573 13.724 14.069C14.156 13.685 14.474 13.355 14.678 13.079C14.894 12.791 15.002 12.467 15.002 12.107C15.002 11.603 14.798 11.195 14.39 10.883C13.982 10.571 13.436 10.415 12.752 10.415C11.456 10.415 10.478 10.877 9.818 11.801L8.072 10.667C8.588 9.95898 9.254 9.41898 10.07 9.04698C10.886 8.66298 11.846 8.47098 12.95 8.47098C14.294 8.47098 15.362 8.76498 16.154 9.35298C16.958 9.92898 17.36 10.727 17.36 11.747C17.36 12.239 17.276 12.671 17.108 13.043C16.952 13.415 16.76 13.733 16.532 13.997C16.304 14.249 16.004 14.543 15.632 14.879C15.176 15.287 14.834 15.647 14.606 15.959C14.39 16.271 14.282 16.643 14.282 17.075H11.996ZM13.148 21.377C12.728 21.377 12.38 21.245 12.104 20.981C11.84 20.705 11.708 20.369 11.708 19.973C11.708 19.577 11.84 19.247 12.104 18.983C12.38 18.719 12.728 18.587 13.148 18.587C13.556 18.587 13.892 18.719 14.156 18.983C14.432 19.247 14.57 19.577 14.57 19.973C14.57 20.369 14.432 20.705 14.156 20.981C13.892 21.245 13.556 21.377 13.148 21.377Z"
                fill="white"
            />
        </svg>
    );

    const bulletIcon = (
        <svg
            width="24"
            height="24"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M12 10a2 2 0 1 0 0 4 2 2 0 1 0 0-4z" />
            <path fill="none" d="M0 0h24v24H0z" />
        </svg>
    );

    return (
        <Card>
            {cardTitle && isWeb && (
                <CardHeader
                    className="web"
                    onClick={() => {
                        setSectionIsOpen(!sectionIsOpen);
                    }}>
                    <CardTitle>{cardTitle}</CardTitle>
                    <IconsWrapper>
                        {!sectionIsOpen && upIcon}
                        {sectionIsOpen && downIcon}
                    </IconsWrapper>
                </CardHeader>
            )}
            {cardTitle && !isWeb && (
                <CardHeader>
                    <CardTitle>{cardTitle}</CardTitle>
                </CardHeader>
            )}
            {(!isWeb || sectionIsOpen || !cardTitle) && (
                <OpenedSection
                    onClick={() => {
                        setSectionIsOpen(false);
                    }}>
                    <LeftColumn>
                        {!!tableData.leftColumn.title && (
                            <Title>{tableData.leftColumn.title}</Title>
                        )}
                        {tableData.leftColumn.data.map((item, i) => {
                            return (
                                <DescWrapper
                                    className={
                                        tableData.type !==
                                            'BENEFITS_CHALLENGES' && !isWeb
                                            ? 'bullet'
                                            : ''
                                    }
                                    key={i}>
                                    {tableData.leftColumn.data.length > 1 && (
                                        <div>
                                            {tableData.type ===
                                            'BENEFITS_CHALLENGES'
                                                ? checkMarkIcon
                                                : isWeb
                                                ? questionMarkIcon
                                                : bulletIcon}
                                        </div>
                                    )}
                                    <div className={'info-description'}>
                                        {!!item.title && (
                                            <span className="sub">
                                                {item.title}
                                            </span>
                                        )}{' '}
                                        {!!item.description && (
                                            <span className="desc">
                                                {item.description}
                                            </span>
                                        )}
                                    </div>
                                </DescWrapper>
                            );
                        })}
                    </LeftColumn>
                    <RightColumn>
                        {!!tableData.rightColumn.title && (
                            <Title>{tableData.rightColumn.title}</Title>
                        )}
                        {tableData.rightColumn.data.map((item, i) => {
                            return (
                                <DescWrapper
                                    className={
                                        tableData.type !==
                                            'BENEFITS_CHALLENGES' && !isWeb
                                            ? 'bullet'
                                            : ''
                                    }
                                    key={i}>
                                    <div>
                                        {tableData.type ===
                                        'BENEFITS_CHALLENGES'
                                            ? exclamationMarkIcon
                                            : isWeb
                                            ? questionMarkIcon
                                            : bulletIcon}
                                    </div>
                                    <div className={'info-description'}>
                                        {!!item.title && (
                                            <span className="sub">
                                                {item.title}
                                            </span>
                                        )}{' '}
                                        {!!item.description && (
                                            <span className="desc">
                                                {item.description}
                                            </span>
                                        )}
                                    </div>
                                </DescWrapper>
                            );
                        })}
                    </RightColumn>
                </OpenedSection>
            )}
        </Card>
    );
};

export default InfoTable;
